import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const SEEN_KEY = 'nav_badges_seen_v1';

const readSeen = () => {
  try { return JSON.parse(localStorage.getItem(SEEN_KEY) || '{}'); }
  catch { return {}; }
};
const writeSeen = (seen) => {
  try { localStorage.setItem(SEEN_KEY, JSON.stringify(seen)); } catch { /* ignore */ }
};

/**
 * Returns { badges: {path: count}, markSeen: (path, currentCount) => void }.
 * Badge counts are *effective* : current - seen (clamped to 0).
 */
export const useNavBadges = (isAdmin) => {
  const [raw, setRaw] = useState({});
  const [seen, setSeen] = useState(readSeen());

  const fetch = useCallback(async () => {
    if (!isAdmin) return;
    try {
      const [alertsRes, pendingRes] = await Promise.all([
        axios.get(`${API_URL}/api/dashboard/alerts`, { withCredentials: true }),
        axios.get(`${API_URL}/api/auth/pending-registrations`, { withCredentials: true }),
      ]);
      const alerts = alertsRes.data?.alerts || [];
      const pending = pendingRes.data || [];
      setRaw({
        '/access': pending.length,
        '/projects': alerts.filter(a => ['no_invoice_month', 'budget_exceeded', 'project_ready_archive'].includes(a.type)).length,
        '/': alerts.length,
      });
    } catch { /* ignore */ }
  }, [isAdmin]);

  useEffect(() => {
    fetch();
    const t = setInterval(fetch, 60000);
    return () => clearInterval(t);
  }, [fetch]);

  // Compute effective badges
  const badges = {};
  Object.keys(raw).forEach(path => {
    const diff = raw[path] - (seen[path] || 0);
    badges[path] = diff > 0 ? diff : 0;
  });

  const markSeen = useCallback((path) => {
    const current = raw[path] || 0;
    const next = { ...seen, [path]: current };
    setSeen(next);
    writeSeen(next);
  }, [raw, seen]);

  return { badges, markSeen, refresh: fetch };
};
